import "./index.css";
import { render } from "react-dom";
import { App } from "./App";
render(<App data-id="element-384" data-mp="3q8m1se9fl0ql" />, document.getElementById("root"));